import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a27c0eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "hand-book-component"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-jp.theckb.com/static-asset/handBook/main_icon.png",
    alt: ""
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "機能ガイド", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "hand-book-drawer-content" }
const _hoisted_6 = { class: "hand-book-drawer-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-jp.theckb.com/static-asset/handBook/handbook_icon.png",
  alt: "",
  class: "hand-book-img"
}, null, -1))
const _hoisted_8 = { class: "title-content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "機能ガイド", -1))
const _hoisted_10 = {
  key: 0,
  class: "position-page"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-jp.theckb.com/static-asset/handBook/position_icon.png",
  alt: ""
}, null, -1))
const _hoisted_12 = { class: "hand-book-drawer-part-outside" }
const _hoisted_13 = { class: "hand-book-drawer-part" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-jp.theckb.com/static-asset/handBook/han_icon.png",
  alt: ""
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "part-hover-content"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "hand-book-drawer-body" }
const _hoisted_20 = { class: "question-title" }
const _hoisted_21 = { class: "question-content" }
const _hoisted_22 = ["innerHTML"]

import { getHandBookListApi } from '@/apis/user'
import { onMounted, ref, watch } from 'vue'
import { guideData } from './data'
import { isD2C, useSite2Station } from '@/store'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const route = useRoute()
const activeKey:any = ref(0)
const visible = ref(false)
const maskVisible = ref(false)
const dataSource: any = ref(guideData.map(v => ({ ...v, list: [] })))
const show = ref(false)
const marginLeft = ['0px', '0px', '-48px', '-128px', '-128px']
const getList = () => {
  getHandBookListApi({
    pageNum: 1,
    pageSize: 10000,
    systemSource: isD2C() ? 1 : 2,
    stationCode: useSite2Station()
  }).then((res) => {
    dataSource.value = guideData.map(v => ({ ...v, list: [] }))
    show.value = !!res.data?.records?.length
    res.data.records?.filter((v: any) => v.stationCode === useSite2Station())?.forEach((item: any) => {
      dataSource.value[item.guideType - 1].list.push(item)
    })
    dataSource.value = dataSource.value.filter(v => v.list?.length)
    if (route.meta.handBook) {
      const arr = route.meta.handBook as string[]
      const val = arr.find(v => dataSource.value.some(i => i.guideType === v))
      if (val) {
        activeKey.value = dataSource.value.findIndex(v => v.guideType === val)
      }
    }
  })
}
// 当页面停留在对应手书内容页面是自动切换
watch(() => store.getters.curShop, (v) => {
  console.log('222222', route.meta?.handBook, store.getters.curShop)
  if (!store.getters.curShop) return
  getList()
}, {
  immediate: true
})
onMounted(() => {
})
const open = () => {
  visible.value = true
  activeKey.value = 0
  getList()
}
const openMask = () => {
  console.log(111)
  maskVisible.value = true
  console.log(maskVisible.value)
}

return (_ctx: any,_cache: any) => {
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_dragY = _resolveDirective("dragY")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (show.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4, 512)), [
          [_directive_dragY, {open: open}]
        ])
      : _createCommentVNode("", true),
    _createVNode(_component_el_drawer, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
      "custom-class": "hand-book-drawer",
      "close-on-click-modal": true,
      "z-index": 3010
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: "https://static-jp.theckb.com/static-asset/handBook/close_icon.png",
            alt: "",
            class: "close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
          }),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              (_unref(route)?.meta?.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("span", null, _toDisplayString(_unref(route).meta.title), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", {
                class: "part-item-content",
                style: _normalizeStyle({ marginLeft: marginLeft[activeKey.value] })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataSource.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["part-item cursor-pt", { active: activeKey.value === index }]),
                    key: index,
                    onClick: ($event: any) => (activeKey.value = index)
                  }, _toDisplayString(item.name), 11, _hoisted_14))
                }), 128))
              ], 4),
              _createElementVNode("div", {
                class: "part-more",
                onClick: openMask
              }, _hoisted_16)
            ]),
            (maskVisible.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "part-more-fixed",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (maskVisible.value = false))
                }))
              : _createCommentVNode("", true),
            (maskVisible.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataSource.value, (item, index) => {
                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["part-item-hover-item", { active: activeKey.value === index }]),
                      key: index,
                      onClick: ($event: any) => (activeKey.value = index)
                    }, _toDisplayString(item.name), 11, _hoisted_18)), [
                      [_vShow, item?.list?.length]
                    ])
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataSource.value[activeKey.value]?.list?.sort((a, b) => a.sort - b.sort), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "question-item",
                key: index
              }, [
                _createElementVNode("div", _hoisted_20, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", {
                    innerHTML: item.content
                  }, null, 8, _hoisted_22)
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})